module.exports = __webpack_public_path__ + "resources/img/img-deep-security-02-4.71871510b716695f4c4a698094c703fe.png";